import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import ReuploadComponent, { ReuploadProps } from "./ReuploadComponent.tsx";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useMail } from "contexts/mailContext/mailContext";
import { useUploader } from "contexts/uploaderContext/uploaderContext";
import "./reuploader.scss";

const ReuploadPortalWrapper = ({
  handleFinishUpload,
}: ReuploadProps): JSX.Element | DocumentFragment => {
  const [portalCreated, setPortalCreated] = useState(false);
  const { getReuploadingMail, getMailMetaData } = useMail();
  const { setUploadId, setMailId, getMailId, setToken } = useUploader();

  const portalElem = document.getElementById("reupload-component");

  const handleGetStatus = async () => {
    const response = await apiRequest("Mails", "ReactGetUploadInfo", {
      encryptedMailId: getReuploadingMail(),
    });
    if (response.status === "success") {
      setToken(response.data.csrf);
    }
  };

  const handleGetToken = async () => {
    if (!getMailMetaData().CSRFToken) {
      await handleGetStatus();
    } else {
      setToken(getMailMetaData().CSRFToken);
    }
  };

  useEffect(() => {
    if (getReuploadingMail() && !portalCreated) {
      handleGetToken();
      const portal = document.createElement("div");
      portal.id = "reupload-component";
      document.body.appendChild(portal);
      setPortalCreated(true);
      setMailId(getReuploadingMail());
      setUploadId(getReuploadingMail());

      return () => {
        document.body.removeChild(portal);
        setPortalCreated(false);
      };
    }
  }, [getReuploadingMail()]);

  return getMailId() && portalCreated && portalElem ? (
    ReactDOM.createPortal(
      <ReuploadComponent handleFinishUpload={handleFinishUpload} />,
      portalElem
    )
  ) : (
    <></>
  );
};

export default ReuploadPortalWrapper;
